type KeywordDifficultySortValue = number | string | null | undefined;

export function isUnknownKeywordDifficultyValue(value: KeywordDifficultySortValue): boolean {
  if (typeof value === 'number') {
    return !Number.isFinite(value) || value <= 0;
  }

  return typeof value === 'string' || value == null;
}
